import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import { Link , useLocation, useParams, useNavigate } from "react-router-dom";
import Sheet from 'react-modal-sheet';
import { BsLink45Deg, BsFillShareFill, BsFillHeartFill, BsCheckCircleFill, BsCartFill, BsHandbagFill, BsTruck, BsFillPersonLinesFill} from "react-icons/bs";
import Star from "../components/Star";
import Coupon from "../components/Coupon";
import mpIcon3 from "../images/mpIcon3.svg";
import {alert,confirm} from "../components/MegConfirmAlert";
import Product3 from "../components/Product3";
import { getCartCookie } from "../services/common";
import { useTranslation } from 'react-i18next';
import ProdList from "../components/ProdList";
import moment from 'moment';
import 'swiper/css';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Autoplay, Navigation, Pagination} from "swiper";

import { useAxios } from "../services/useAxios";
import { Windows } from "react-bootstrap-icons";



export default function ProductDetail() {
    const { t } = useTranslation();
    const location = useLocation();
    const [isOpen, setOpen] = useState(false);
    const [isShareOpen, setShareOpen] = useState(false);
    const [couponOpen, setCouponOpen] = useState(false);
    
    const [couponInfo, setCouponInfo] = useState({});
    
    let {id} = useParams();
    const lang = localStorage.getItem("language") || "ko";
    let recentGoods = localStorage.getItem("recentGoods")?JSON.parse(localStorage.getItem("recentGoods")):[];
    const [request] = useAxios();
    const navigate = useNavigate(); 
    const [data, setData] = useState({});

    const [downCouponCnt, setDownCouponCnt] = useState(0);

    
    const [heart, setHeart] = useState(data.goodsInfoVO && data.goodsInfoVO.likeAt && data.goodsInfoVO.likeAt === 'Y');
    const handleHeart = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {
            ConfirmPick();
            return;
        }else{
            console.log(data)
            const response = await request.post("/app/wishlist/procMyWishListAPI", {
                likeAt : heart?"N":"Y",
                goodsSn : data.goodsInfoVO.goodsSn,
                likeSn : data.goodsInfoVO.likeSn,
            });
            if(response.data.resultCode === 200){                
                setHeart(!heart);
            }
        }
        
    }

    const ConfirmPick = async () => {
        const result = await confirm(t(`Message.common_login_page_msg1`) + '\n' + t(`Message.common_login_page_msg2`), {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            navigate('/LogIn', {
                state: { from: location },
              })
        }
    }

    const fn_maxCount = () => {
        if(data.goodsInfoVO.goodsBuyLimitOptionCode === '1DAY'){
            return t(`Message.goods_detail_screen_goods_buy_limit1` , {goodsBuyLimitValue : data.goodsInfoVO.goodsBuyLimitValue});
        }else  if(data.goodsInfoVO.goodsBuyLimitOptionCode === '1MAN'){
            return t(`Message.goods_detail_screen_goods_buy_limit2` , {goodsBuyLimitValue : data.goodsInfoVO.goodsBuyLimitValue});
        }else{
            return t(`Message.goods_detail_screen_goods_buy_limit3` , {goodsBuyLimitValue : data.goodsInfoVO.goodsBuyLimitValue});
        }
    }
    
    

    const fn_allCouponDown = async () => {    
        const response = await request.post("/app/goods/addAllCouponIssuAPI", {});
        console.log(response.data)
        if(response.data.resultCode === 200){
            alert(t(`Message.coupon_list_bottom_sheet_coupon_issu_sucss`));  
            setCouponOpen(false)    
        }else{
            alert(response.data.resultMessage)
        }
        
    }

    const fn_clickCoupon = async (obj) => {    
        const response = await request.post("/app/goods/addCouponIssuAPI", obj);
        console.log(response.data)
        if(response.data.resultCode === 200){
            alert(t(`Message.coupon_list_bottom_sheet_coupon_issu_sucss`));  
            setCouponOpen(false)
        }else{
            alert(response.data.resultMessage)
        }
    }

    const fn_getCoupon = async () => {    
        
        const response = await request.post("/app/goods/getCouponIssuListAPI", {
            goodsClSn : data.goodsInfoVO.goodsClSn,
            goodsSn : data.goodsInfoVO.goodsSn,
        });
        if(response.data.resultCode === 200){
            
            const cnt = (response.data.result.couponIssuList && response.data.result.couponIssuList.length !==0)?
             response.data.result.couponIssuList.findIndex((obj) => (obj.couponUseAt === 'N' && obj.useEndDe === '' && obj.userId === '' )):0;                         
            setDownCouponCnt(cnt)

            setCouponInfo(response.data.result)
            
        }
        setCouponOpen(true)
    }

    const fetchData = async () => {

        const response = await request.post("/app/goods/getGoodsDetailAPI", {
            nationSeCode : lang,
            goodsSn : id
        });
        if(response.data.resultCode === 200){
            
           
            const idx = recentGoods.findIndex(function(item) {return item.goodsSn === response.data.result.goodsInfoVO.goodsSn});            
            if (idx > -1)  {
                recentGoods.splice(idx, 1);
            }            
            recentGoods.unshift(response.data.result.goodsInfoVO)            
            recentGoods = recentGoods.slice(0,2);            
            localStorage.setItem("recentGoods", JSON.stringify(recentGoods));
           
            setHeart(response.data.result.goodsInfoVO.likeAt==="Y")
            console.log(response.data.result)
            setData(response.data.result);
        }            
    };

    const fn_kakaoShare = () =>{
        console.log(window.Kakao)
        if(window.Kakao){
            const kakao = window.Kakao;
            kakao.Share.sendDefault({
                objectType: 'commerce',
	    		  content: {
	    		    title: '아직 SALEE 회원이 아니세요? SALEE에 오신걸 환영합니다.',
	    		    imageUrl:
	    		      'https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?searchCnd=M&goodsFileTy=i&goodsFileSn='+data.goodsInfoVO.goodsFileSn,
	    		    link: {
	    		      mobileWebUrl: 'https://m.salee.co.kr/ProductDetail/'+data.goodsInfoVO.goodsSn,
	    		      webUrl: 'https://salee.co.kr/shop/goods/moveGoodsView.sale?goodsSn='+data.goodsInfoVO.goodsSn,
	    		    },
	    		  },
	    		  commerce: {
	    		    productName: data.goodsInfoVO.goodsNm,
	    		    regularPrice: Number(data.goodsInfoVO.nrmltAmount),
	    		    discountRate:  data.goodsInfoVO.nrmltAmount===0?'':Math.round(100-(data.goodsInfoVO.sleAmount*100/data.goodsInfoVO.nrmltAmount)),
	    		    discountPrice: Number(data.goodsInfoVO.sleAmount),
	    		  },
	    		  buttons: [
	    		    {
	    		      title: t(`Message.add_cart_bottom_sheet_buying`),
	    		      link: {
	    		        mobileWebUrl: 'https://m.salee.co.kr/ProductDetail/'+data.goodsInfoVO.goodsSn,
	    		        webUrl: 'https://salee.co.kr/shop/goods/moveGoodsView.sale?goodsSn='+data.goodsInfoVO.goodsSn,
	    		      },
	    		    },
	    		    {
	    		      title: '공유하기',
	    		      link: {
	    		        mobileWebUrl: 'https://m.salee.co.kr/ProductDetail/'+data.goodsInfoVO.goodsSn,
	    		        webUrl: 'https://salee.co.kr/shop/goods/moveGoodsView.sale?goodsSn='+data.goodsInfoVO.goodsSn,
	    		      },
	    		    },
	    		  ]
            })
        }
    }
    useEffect(() => {
        if(!window.Kakao.isInitialized()){            
            window.Kakao.init('d51ac7189be423197f3a6a450e47d47a')
        }
        fetchData();
      }, []);

    return(

        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={data.goodsInfoVO && data.goodsInfoVO.goodsNm}/>
                <div className="tabArea">
                    <Link to="" className="tabBtn active">{t(`Message.goods_detail_screen_tab_title1`)}</Link>
                    <Link to={"/ProductBuyInfo/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title2`)}</Link>
                    <Link to={"/ProductReview/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title3`)} {data.goodsReviewCnt && data.goodsReviewCnt}</Link>
                    <Link to={"/ProductQnA/"+id} className="tabBtn">{t(`Message.goods_detail_screen_tab_title4`)} {data.goodsInqryCnt && data.goodsInqryCnt}</Link>
                </div>
            </div>

            {data.goodsInfoVO?(
            <div className="productDetailWr">
                <div className="pdImgWr">
                    <Swiper className="prodDetailSlide" 
                        slidesPerView={1}
                        spaceBetween={0}
                        autoplay={{delay: 5000}}
                        loop = "true"
                        pagination={{ clickable: false }}
                    >
                        {data.goodsImageMapList && data.goodsImageMapList.map((obj, index) => (   
                        <SwiperSlide key={index}>
                            <img key={index} src={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?searchCnd=M&goodsFileTy=i&goodsFileSn="+obj.goodsImageSn} alt={data.goodsInfoVO && data.goodsInfoVO.goodsNm} />
                        </SwiperSlide>
                        ))}                   
                    </Swiper>
                  
 
                  
                    <div className="btnWr">
                        <button 
                            className="pickBtn" 
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                handleHeart();
                            }}>
                            { heart ? (<BsFillHeartFill className="active" />) : (<BsFillHeartFill />) }
                        </button>
                        <button 
                            type="button" 
                            className="shareBtn cNavy"
                            onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                setShareOpen(true);
                            }}
                        >
                            <BsFillShareFill />
                        </button>
                    </div>
                </div>

                <div className="pdNameWr">
                    <p className="name">{data.goodsInfoVO && data.goodsInfoVO.goodsNm}</p>
                    <Star type="star1" obj={data.goodsInfoVO} />
                    
                    <div className="dfcsG8">
                        <p className="cost">{data.goodsInfoVO && data.goodsInfoVO.nrmltAmount.toLocaleString('ko-KR')}</p>
                    </div>
                    <p className="disprice">{data.goodsInfoVO && data.goodsInfoVO.sleAmount.toLocaleString('ko-KR')}</p>
                    <button
                        type="button"
                        className="couponBtn"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            fn_getCoupon();
                        }}
                    >
                        <img src={mpIcon3} alt={t(`Message.my_salee_screen_coupon`)} />
                        <span>{t(`Message.my_order_detail_payment_info_coupon_sle_amt`)}</span>
                    </button>
                </div>


                <ul className="basicInfo">
                    <li>
                        <div className="titWr">
                            <BsCheckCircleFill />
                            <p className="tit">{t(`Message.goods_detail_screen_origin_title`)}</p>
                        </div>
                        <div className="contWr">
                            <p>{data.goodsInfoVO?.orgplceNm}</p>
                        </div>
                    </li>
                    <li>
                        <div className="titWr">
                            <BsCheckCircleFill />
                            <p className="tit">{t(`Message.goods_detail_screen_buy_unit_title`)}</p>
                        </div>
                        <div className="contWr">
                            <p>{data.goodsInfoVO?.sleUnitNm}</p>
                        </div>
                    </li>
                    <li>
                        <div className="titWr">
                            <BsCheckCircleFill />
                            <p className="tit">{t(`Message.goods_detail_screen_volume_title`)}</p>
                        </div>
                        <div className="contWr">
                            <p>{data.goodsInfoVO?.qyUnitNm}</p>
                        </div>
                    </li>
                    <li>
                        <div className="titWr">
                            <BsCheckCircleFill />
                            <p className="tit">{t(`Message.goods_detail_screen_buy_goods_no_title`)}</p>
                        </div>
                        <div className="contWr">
                            <p>{data.goodsInfoVO?.sleGoodsNo}</p>
                        </div>
                    </li>
                    <li>
                        <div className="titWr">
                            <BsCheckCircleFill />
                            <p className="tit">{t(`Message.goods_detail_screen_dlvy_info_title`)}</p>
                        </div>
                        <div className="contWr">
                            {data.goodsDlvyDcInfoVO.dlivyReqreDaycnt === 0?(
                                <p>{t(`Message.goods_detail_screen_dlvy_arrv_msg1`)} ({data.tomorrow} 도착예정)</p>
                            ):null}
                            {data.goodsDlvyDcInfoVO.dlivyReqreDaycnt > 0?(
                                <p>{moment().format("YYYY-MM-DD")} + {data.goodsDlvyDcInfoVO.dlivyReqreDaycnt} ({data.tomorrow} 도착예정)</p>
                            ):null}
                            <p>{t(`Message.goods_detail_screen_basic_shp_cost_title`)} ￦{data.goodsDlvyDcInfoVO && data.goodsDlvyDcInfoVO.dfltDlvyCtAmount.toLocaleString('ko-KR')}</p>                        
                            <p style={{color:"red"}}>{data.goodsDlvyDcInfoVO && data.goodsDlvyDcInfoVO.dfltDlvyCtSeCodeNm}</p>

                        </div>
                    </li>                    
                </ul>
                <div className="pr20 pl20">
                    <ul className="haaaa">
                        <li>
                            <p className="leftT"><BsFillPersonLinesFill /> {t(`Message.goods_detail_screen_seller_nm`)}</p>
                            <p className="rightT">{data.goodsInfoVO?.selerNm}</p>
                        </li>
                        <li>
                            <p className="leftT"><BsHandbagFill /> {t(`Message.goods_detail_screen_mxm_qy`)}</p>
                            <p className="rightT">
                                {data.goodsInfoVO.goodsBuyLimitOptionCode?( fn_maxCount()):(t(`Message.goods_detail_screen_goods_buy_limit4`))}
                            </p>
                        </li>
                        <li>
                            <p className="leftT"><BsTruck /> {t(`Message.goods_detail_screen_dlvy_co`)}</p>
                            <p className="rightT">{data.goodsDlvyDcInfoVO?.hdryCmpnySeCodeNm}</p>
                        </li>
                    </ul>
                </div>

                <div className="promoImgWr">                    
                    {data.goodsDcMapList && data.goodsDcMapList.map((obj, index) => (  
                        <div key={index}>
                            {obj.goodsDcImagePhysclNm?(
                                <img src={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=d&goodsFileSn="+obj.goodsDcSn} alt={"제품설명"+index} />
                            ):(
                                <>
                                {obj.goodsDcCn}
                                </>
                            )}
                        </div>
                    ))} 
                </div>


                <div className="bottomBtnWr">
                    <button 
                        type="button" 
                        className="btn48 cFFF orgB"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation(); 
                            setOpen(true);
                        }}>
                        {t(`Message.bottom_navigation_bar_order_btn`)}
                    </button>
                </div>
            </div>
            ):null}


            <ProdList id={id} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>




            {/* sns 공유 모달 */}
            <Sheet isOpen={isShareOpen} onClose={() => setShareOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 pr20 pl20 pb30 pt10">
                       <a href="#n" className="modalShare snsList" onClick={(e)=>fn_kakaoShare()}><span className="snsBtn snsLinkKa"></span><span>카카오톡 공유</span></a>
                       <a href="#n" className="modalShare snsList" onClick={(e)=>{
                            
                            const url = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent("https://m.salee.co.kr/ProductDetail/"+data.goodsInfoVO?.goodsSn);
                            console.log(url)
                            window.open(url, "", "width=486, height=286");
                       }}><span className="snsBtn snsLinkFb"></span><span>페이스북 공유</span></a>
                       <a href="#n" className="modalShare" onClick={async (e)=> {
                        await navigator.clipboard.writeText("https://m.salee.co.kr/ProductDetail/"+data.goodsInfoVO?.goodsSn);
                        alert('URL이 복사되었습니다', {okText:'확인'}); 
                       }}><BsLink45Deg className="shareIcon" /><span>링크 복사</span></a>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setShareOpen(false)}/>
            </Sheet>



            {/* 쿠폰모달 */}
            <Sheet isOpen={couponOpen} onClose={() => setCouponOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="dfColG16 pr20 pl20 pb10">
                        <p className="btModalTit">{t(`Message.coupon_list_bottom_sheet_coupon`)}</p>
                        <div className="mdCpWr">
                            <div className="dfColG12">
                                {couponInfo.couponIssuList &&  couponInfo.couponIssuList.map((obj, index) => (
                                <Coupon  key={index}
                                    type={(obj.couponUseAt === 'N' && obj.useEndDe === '' && obj.userId === '' )?"down":"downFin"} 
                                    discount={obj.couponValue + obj.couponValueUnitCodeNm+' 할인'}
                                    name={obj.couponSj}
                                    info={t(`Message.coupon_list_bottom_sheet_coupon_condition_2`, {mxmmAmt : obj.mxmmDscntAmount.toLocaleString('ko-KR')}) + ', ' + t(`Message.coupon_list_bottom_sheet_coupon_condition_3`, {mummAmt : obj.mummUsePosblAmount.toLocaleString('ko-KR')})}  
                                    date={"~ "+obj.useEndDe}
                                    downClick={fn_clickCoupon}
                                    obj = {obj}
                                />
                                ))}                                    
                            </div>
                        </div>
                    </div>
                    <div className="btnWr">
                        {downCouponCnt >= 0?(
                        <button type="button" className="buyBtn" onClick={fn_allCouponDown}>{t(`Message.coupon_list_bottom_sheet_all_coupon`)}</button>
                        ):null}
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setCouponOpen(false)}/>
            </Sheet>
        </div>
    );
};